/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject";

export default class BaseAccessObject extends DbBaseObject{

	ownerIds: string[] = [];

	readOwnerIds: string[] = [];
	writeOwnerIds: string[] = [];


	constructor(){
		super()
	}

	addReadPermissionFor(objectIds){
		this.addIds(objectIds, this.readOwnerIds)
	}
	revokeReadPermissionFor(objectIds){
		this.removeIds(objectIds, this.readOwnerIds)
		this.revokeWritePermissionFor(objectIds)
	}
	addWritePermissionFor(objectIds){
		this.addIds(objectIds, this.writeOwnerIds)
		this.addReadPermissionFor(objectIds)

	}
	revokeWritePermissionFor(objectIds){
		this.removeIds(objectIds, this.writeOwnerIds)
	}



	canRead(objectId){
		let hasItem = this.readOwnerIds.some(item => item == objectId)
		return hasItem || this.readOwnerIds.length == 0
	}

	canWrite(objectId){
		let hasItem = this.writeOwnerIds.some(item => item == objectId)
		return hasItem || this.writeOwnerIds.length == 0
	}
}
